import './AgentsPerformanceHeader.css';
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import AnalyticsCard from '../../../analytics/components/AnalyticsCard/AnalyticsCard';
import ProgressCircle from '../../../../../components/UI/ProgressCircle/ProgressCircle';
import { Doughnut } from "react-chartjs-2";
import { Box } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const CONVERSATIONS_LIST_PATH = '/supervision/conversations/list';

function AgentsPerformanceHeader({ stats: statsProp = {}, isLoading = false, agentFilter }) {
    const viewInteractionsHref = agentFilter
        ? `${CONVERSATIONS_LIST_PATH}?agent_id=${encodeURIComponent(agentFilter)}`
        : CONVERSATIONS_LIST_PATH;

    const stats = {
        overallScore: 0,
        interactions: 0,
        avgVoiceDuration: 0,
        speakerRatio: { agent: 0, prospect: 0 },
        training: { completed: 0, assigned: 0, overdue: 0 },
        ...statsProp,
        speakerRatio: statsProp.speakerRatio || { agent: 0, prospect: 0 },
        training: statsProp.training || { completed: 0, assigned: 0, overdue: 0 },
    };


    const rootStyles = getComputedStyle(document.documentElement);

    const mainColor = rootStyles.getPropertyValue('--main').trim();
    const grayColor = rootStyles.getPropertyValue('--gray').trim();

    const data = {
        labels: ['Prospect', 'Agent'],
        datasets: [
            {
                data: [stats.speakerRatio.prospect, stats.speakerRatio.agent],
                backgroundColor: [grayColor, mainColor],
                borderColor: [grayColor, mainColor],
                borderWidth: 0,
                hoverBorderWidth: 0
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false,
            }

        }
    }

    return (
        <div className="agents-performance-header" >

            {/* Overall Score */}
            < AnalyticsCard title="Overall Score" titleSize="16px" height="30px" removePaddingTitle={true} >
                <Tippy
                    className="progress-circle-tooltip"
                    content={
                        <div className="progress-circle-warning-tooltip">
                            Average percentage of passed criteria across all evaluated calls.
                        </div>
                    }
                    placement="bottom"
                    delay={[200, 0]}
                >
                    <div className="progress-circle-container-agents-performance-header">
                        <ProgressCircle value={stats.overallScore} />
                    </div>
                </Tippy>
            </AnalyticsCard >

            {/* Number of Interactions */}
            < AnalyticsCard title="Number of interactions" titleSize="16px" height="30px" >
                <div className="card-content">
                    <div className="card-value">{stats.interactions.toLocaleString()}</div>
                    <a href={viewInteractionsHref} className="card-link" target="_blank" rel="noopener noreferrer">View interactions →</a>
                </div>
            </AnalyticsCard >

            {/* Avg Voice Interaction Duration */}
            < AnalyticsCard title="Avg. Voice interaction duration" titleSize="16px" height="30px" >
                <div className="card-value">{stats.avgVoiceDuration} mins</div>
            </AnalyticsCard >

            {/* Speaker Ratio */}
            < AnalyticsCard title="Speaker ratio" titleSize="16px" height="30px" >
                <div className="speaker-ratio">
                    <div className="speaker-ratio-container">
                        <div className='title-speaker-ratio'>{stats.speakerRatio.agent}%</div>
                        <p>Agent</p>
                    </div>

                    <Box sx={{ width: 80, height: 80, position: 'relative', zIndex: 10 }}>
                        <Doughnut data={data} options={options} />
                    </Box>
                    <div className="speaker-ratio-container">
                        <div className='title-speaker-ratio'>{stats.speakerRatio.prospect}%</div>
                        <p>Prospect</p>
                    </div>
                </div>
            </AnalyticsCard >

            {/* Training */}
            < AnalyticsCard title="Training" titleSize="16px" height="30px" >
                <div className="training-values">
                    <div className="training-container">
                        <div className='training-value'>{stats.training.completed}</div>
                        <div className="trainer-bottom">
                            <i className="fas fa-check" style={{ color: "var(--green)" }}></i>
                            <br></br>
                            <br></br>
                            <span>Completed</span>
                        </div>
                    </div>
                    <div className="training-container">
                        <div className='training-value'>{stats.training.assigned}</div>
                        <div className="trainer-bottom">
                            <i className="fas fa-bookmark" style={{ color: "var(--orange)" }}></i>
                            <br></br>
                            <br></br>
                            <span>Assigned</span>
                        </div>

                    </div>
                    <div className="training-container">
                        <div className='training-value'>{stats.training.overdue}</div>
                        <div className="trainer-bottom">
                            <i className="fas fa-exclamation-triangle" style={{ color: "var(--pink)" }}></i>
                            <br></br>
                            <br></br>
                            <span>Overdue</span>
                        </div>

                    </div>
                </div>
            </AnalyticsCard >

        </div >
    );
}

export default AgentsPerformanceHeader;